import { Typography, Box } from '@mui/material'

export default function ProctorDashboard() {
   return (
      <Box>
         <Typography variant="h4">STS Matematika</Typography>
         <Typography>Tahun Ajaran 2025/2026</Typography>
      </Box>
   )
}
